module.exports = __webpack_public_path__ + "img/Rangers_dot_com.2ea9d35b.svg";